import { render, staticRenderFns } from "./FinancialAssessment.vue?vue&type=template&id=49a1cf24"
import script from "./FinancialAssessment.vue?vue&type=script&lang=js"
export * from "./FinancialAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports